/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ledger_Query_Save_FailedInputs */

const en_ledger_query_save_failed = /** @type {(inputs: Ledger_Query_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not save the source query.`)
};

const nl_ledger_query_save_failed = /** @type {(inputs: Ledger_Query_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De bronquery kon niet worden opgeslagen.`)
};

/**
* | output |
* | --- |
* | "Could not save the source query." |
*
* @param {Ledger_Query_Save_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const ledger_query_save_failed = /** @type {((inputs?: Ledger_Query_Save_FailedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ledger_Query_Save_FailedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_ledger_query_save_failed(inputs)
	return en_ledger_query_save_failed(inputs)
});